import { configureStore } from '@reduxjs/toolkit';
import { conversion } from '../app/MACRA_1/middleware/conversion';
import store from '../app/store';
import { conversionMacra2 } from '../app/MACRA_2/middleware/conversion';

export const redux = configureStore({
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(conversion).concat(conversionMacra2),
    reducer: store,
});

export const getState = () => redux.getState();

export type RootState = ReturnType<typeof redux.getState>;

export type AppDispatch = typeof redux.dispatch;

export interface IInitialState<T> {
    data?: T;
    error?: IError;
    pending?: boolean;
    showDischargeAlert?: boolean;
    initialState: boolean;
}

export interface IError {
    status: number;
    data: string;
}
